import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingAccounts = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_ACCOUNT] : (state,action)=>action.status
})

export default RetrievingAccounts
